<template>
  <div class="paySuccess">
    <div v-if="$route.query.key == 1">
      <el-drawer
        :visible.sync="paySuccess"
        :show-close="false"
        :wrapperClosable="false"
      >
        <div class="cont" v-if="orderData">
          <div class="successIcon">
            <i class="el-icon-success"></i>
            <span class="success-hint">订单创建成功</span>
          </div>
          <div class="order_infor">
            <div class="order_cont">
              <span class="explain">订单信息</span>
            </div>
            <div class="order_cont">
              <span class="explain">支付金额</span>
              <span class="order_cont_infor">¥{{ orderData.money }}</span>
            </div>
            <div class="order_cont">
              <span class="explain">订单创建时间</span>
              <span class="order_cont_infor">{{ orderData.create_time }}</span>
            </div>
          </div>
          <div class="order-operation" v-if="orderData.payment_code == 'cash'">
            <el-button
              type="info"
              plain
              @click="delconfirmOrderItems(orderData.id)"
            >取消订单</el-button
            >
            <el-button
              type="success"
              plain
              @click="confirmOrderItems(orderData.paysn)"
              >确认收款</el-button
            >
          </div>
          <div style="margin-top: 10px;margin-left: 30px">
            <!--            <el-button size="small" round @click="printReceipt" type="primary">-->
            <!--              打印小票-->
            <!--            </el-button>-->
<!--            <el-button-->
<!--              size="small"-->
<!--              round-->
<!--              @click="-->
<!--                paySuccess = false;-->
<!--                $emit('payEnd');-->
<!--              "-->
<!--              type="primary"-->
<!--            >-->
<!--              关掉该页面-->
<!--            </el-button>-->
          </div>
        </div>
      </el-drawer>
    </div>
    <div v-else>
      <el-drawer
        :visible.sync="paySuccess"
        :show-close="false"
        :wrapperClosable="false"
      >
        <div class="cont" v-if="orderData">
          <div class="successIcon">
            <i class="el-icon-success"></i>
            <span class="success-hint">订单创建成功</span>
            <div class="price">
              ¥
              <span>{{ orderData.amount }}</span>
            </div>
          </div>
          <div class="order_infor">
            <div class="order_cont">
              <span class="explain">加油信息</span>
              <span class="order_cont_infor">{{ name }}</span>
            </div>
            <div class="order_cont">
              <span class="explain">支付金额</span>
              <span class="order_cont_infor">¥{{ orderData.money }}</span>
            </div>
            <div class="order_cont">
              <span class="explain">加油量</span>
              <span class="order_cont_infor">{{ fuel_charge }}L</span>
            </div>
            <div class="order_cont">
              <span class="explain">优惠券抵扣</span>
              <span class="order_cont_infor"
                >¥{{ orderData.coupon_dec_money||0 }}</span
              >
            </div>
            <div class="order_cont">
              <span class="explain">积分抵扣</span>
              <span class="order_cont_infor"
                >¥{{ orderData.point_dec_money||0 }}</span
              >
            </div>
            <div class="order_cont">
              <span class="explain">会员减免</span>
              <span class="order_cont_infor"
                >¥{{ orderData.discount_dec_money||0 }}</span
              >
            </div>
            <div class="order_cont">
              <span class="explain">会员手机号</span>
              <span class="order_cont_infor">{{ user.mobile }}</span>
            </div>
            <div class="order_cont">
              <span class="explain">订单编号</span>
              <span class="order_cont_infor">{{ order.ordersn }}</span>
            </div>
            <div class="order_cont">
              <span class="explain">订单创建时间</span>
              <span class="order_cont_infor">{{nowDate}}</span>
            </div>
          </div>
          <div class="order-operation" v-if="orderData.payment_code == 'cash'">
            <el-button
              type="info"
              plain
              @click="confirmOrderItem(order.ordersn, 2)"
              >取消订单</el-button
            >
            <el-button
              type="success"
              plain
              @click="confirmOrderItem(order.ordersn, 1)"
              >确认收款</el-button
            >
          </div>
          <div style="margin-top: 10px;margin-left: 30px">
            <el-button size="small" round @click="printReceipt" type="primary">
              打印小票
            </el-button>
            <el-button
              size="small"
              round
              @click="
                paySuccess = false;
                $emit('payEnd');
              "
              type="primary"
            >
              关掉该页面
            </el-button>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { cancelOrder, confirmOrder, orderPrint } from "@/api/vip";
import { confirm_order_money } from "@/api/order";
import { orderDelete } from "@/api/integralMall";

let moment = require("moment")
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      paySuccess: false,
      orderData: "",
      confirmData: {},
      order:{},
      fuel_charge:0,
      name:'',
      user:{},
      nowDate:''
    };
  },
  mounted() {
    this.nowDate = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm')
  },
  methods: {
    ...mapActions(["delShop_car"]),
    //便利店现金确认收款
    async confirmOrderItems(sn) {
      const res = await confirm_order_money({
        app_id: this.app_id,
        paysn: sn,
        payment_code: this.orderData.payment_code
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "订单确认成功"
        });
        this.delShop_car()
        this.paySuccess = false;
        location.reload();
      }
    },
    //便利店订单取消
    async delconfirmOrderItems(id){
      const res = await orderDelete({
        app_id:this.app_id,
        id:id
      })
      if(res.code == 200){
        this.$message.success('订单取消成功')
        this.paySuccess = false;
      }else {
        this.$message.error(res.msg)
      }
    },
    // 打印小票
    printReceipt(id) {
      this.$confirm("确定打印该订单的小票?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          orderPrint({ id: this.order.order_id, app_id: this.app_id }).then(
            res => {
              if (res.responseCode == 0) {
                this.$message.success(res.msg);
              } else {
                this.$message(res.msg);
              }
            }
          );
        })
        .catch(() => {});
    },
    // 确认未支付订单窗口
    confirmOrderItem(ordersn, type) {
      this.confirmData = {
        ordersn: ordersn,
        type: "cash"
      };
      if (type == 1) {
        this.confirmOrderSubmit();
      } else {
        this.cancelOrderSubmit();
      }
    },
    // 确认未支付订单
    confirmOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
        payment_code: this.confirmData.type
      };
      confirmOrder(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "订单确认成功"
          });
          this.paySuccess = false;
          this.$emit("payEnd");
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 取消未支付订单
    cancelOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn
      };
      cancelOrder(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "取消成功"
          });
          this.paySuccess = false;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cont {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .successIcon {
    text-align: center;
    display: flex;
    flex-direction: column;
    color: #00c250;

    .el-icon-success {
      font-size: 80px;
      margin-bottom: 10px;
    }
    .success-hint {
      font-size: 24px;
      margin-bottom: 3px;
    }
    .price {
      color: #ff1207;
      font-size: 14px;
      span {
        font-size: 34px;
        font-weight: 500;
      }
    }
  }

  .order_infor {
    margin-top: 20px;
    padding: 0 30px;
    .order_cont {
      font-size: 20px;
      color: #333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
    .order_cont_infor {
      color: #333;
    }
  }
  .order-operation {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    .el-button {
      width: 35%;
    }
  }
}
</style>
